import React from "react";

import Richtext from "../Richtext";

import PdfCover from "./PdfCover";
import PdfProductTree from "./PdfProductTree";
import PdfToc from "./PdfToc";

import type { PdfProductPageProps } from "./types.d";

export default function PdfProductPage(props: Readonly<PdfProductPageProps>) {
  const {
    printCover,
    toc,
    bodyHtml,
    tree,
    isNormen,
    legalOwnerAndContributors,
    lang,
    showTocMarkers,
    showTocPageNumberPlaceholders
  } = props;

  return (
    <>
      <PdfCover
        print={printCover}
        isNormen={isNormen}
        breakPage
        legalOwnerAndContributors={legalOwnerAndContributors}
        lang={lang}
      />

      <PdfToc toc={toc} showPageNumberPlaceholders={showTocPageNumberPlaceholders} />

      {tree ? <PdfProductTree list={tree} showTocMarkers={showTocMarkers} /> : bodyHtml && <Richtext text={bodyHtml} />}
    </>
  );
}
